import { createSlice } from "@reduxjs/toolkit";

const initialPageState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  countryList: [],
  usersCount: null,
  allCountryList: null,
  newPage: {},
  PageForEdit: {},
  itemPage: {},
  deletePage: {},
 
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const Slice = createSlice({

  name: "Page",
  initialState: initialPageState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    PageList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    createPage: (state, action) => {
      const { newPage } = action.payload;
      state.error = null;
      state.newPage = newPage;
    },
    deletePage: (state, action) => {
      const { deletePage } = action.payload;
      state.error = null;
      state.deletePage = deletePage;
    },
    singleItemFetched: (state, action) => {
      state.actionsLoading = false;
      state.PageForEdit = action.payload.PageForEdit;
      state.error = null;
    },

  }
});
